import { IContratosGerados, IContratosStatus } from "../../../Interfaces/Geral/ContratosGerados/ContratosGeradosInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function GetContratoPorCasoService(idCaso: number) {
    return Service(
        Axios.get<Array<IContratosGerados>>(`/home/contrato/getcontratoporcaso?idCaso=${idCaso}`)
    )
}

export async function ListaContratoStatusService() {
    return Service(
        Axios.get<Array<IContratosStatus>>(`/home/contrato/listacontratostatus`)
    )
}

export function AtualizaContratoService(responseBody: IContratosGerados) {
    return Service(
        Axios.put(`/home/contrato/atualizacontrato`, responseBody)
    )
}

export function ExportHTMLtoPDFService(requestBody: {strHTML: string}) {
    return Service(
        Axios.post(`/home/documentos/exportadocumentohtmlparapdf`, requestBody, {responseType : 'blob'})
    )
}